const getters = {
  dialerData: (state) => state.dialerData
};

export default {
  getters
};
